module.exports = __webpack_public_path__ + "static/media/white_line_why.47d299e8.svg";